// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductCard_wrapper__8DxKv","container":"ProductCard_container__cdrf0","image":"ProductCard_image__exZ38","learn":"ProductCard_learn__AR6Ph"};